import React, {useCallback, useState} from "react";
import {Button, Input, Modal} from "antd";
import userApi from "../../users/services/users.service";
import styled from "styled-components";
import {useResourceContext} from "../../common/resource/useResourceContext";

const PenaltyModal = ({modalState, setModalState, setForceReload, userId, rideId}) => {
  const {R} = useResourceContext()

  const [penaltyReason, setPenaltyReason] = useState("");
  const [amount, setAmount] = useState(0);
  const [loading, setLoading] = useState(false);

  const hideModal = useCallback(() => {
    setModalState((prev) => ({...prev, isVisible: false}));
  }, [setModalState]);

  const handleOnClick = async () => {
    if (amount < 100) return alert("100원 이상 패널티 금액을 입력해주세요!")
    setLoading(true);
    userApi.createUserPenalty(userId, {
      amount: parseInt(amount, 10),
      reason: penaltyReason,
      rideId
    }).then(() => {
        alert(amount + "원 패널티 부과 완료");
        setLoading(false);
        hideModal();
        setForceReload();
      }
    ).catch((e) => {
      alert(e.response?.data?.message || "패널티 부과 중 오류가 발생했습니다.");
      setLoading(false);
    });
  }

  const ModalFooter = () => {
    return <>
      <Button type='default' onClick={hideModal}>취소</Button>
      <Button disabled={loading} onClick={handleOnClick} type='primary' danger>패널티 부과</Button>
    </>
  }

  return (
    <>
      <Modal
        title={`${R.text.penalty || '패널티 부과'}`}
        width={304}
        visible={modalState.isVisible}
        onCancel={hideModal}
        footer={<ModalFooter/>}>
        <ModalContentWrapper>
          <InputWrapper>
            <p className={"label"}>금액: </p>
            <Input
              type="number"
              style={{width: "200px"}}
              value={amount}
              onChange={(event) => {
                setAmount(event.target.value);
              }}/>
          </InputWrapper>
          <InputWrapper>
            <p className={"label"}>사유: </p>
            <Input
              style={{width: "200px"}}
              value={penaltyReason}
              onChange={(event) => {
                setPenaltyReason(event.target.value);
              }}/>
          </InputWrapper>
          <br/>
          <p>패널티를 부과하시겠습니까?</p>
        </ModalContentWrapper>
      </Modal>
    </>
  );
};

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 8px;
  align-items: center;

  .label {
    margin: 0 16px 0 0;
  }
`

const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export default PenaltyModal
